export default __webpack_public_path__ + "static/media/flexfitCatalogue2021-400x482.68b6cb68.jpg";